let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lyYgq")).then(() => parcelRequire('5jeMe'));